import React from 'react';
import { Button, Stack, Typography, Tooltip, Badge } from '@mui/material';
import {
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
} from '@mui/x-data-grid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';

import { useNavigate } from 'react-router';

import { getProjectAuthorizerFormPath } from '@/util/routePaths';

function ProjectAuthorizersGridToolbar({ project, disabled }) {
  const navigate = useNavigate();

  return (
    <Toolbar
      sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    >
      <Stack direction='row' spacing={1}>
        <Button
          color='brand'
          variant='outlined'
          disabled={disabled}
          onClick={() => navigate(getProjectAuthorizerFormPath(project.id))}
        >
          <Stack direction='row' spacing={1} alignItems='center'>
            <AddCircleOutlineIcon />
            <Typography variant='button' display='block' gutterBottom>
              Add
            </Typography>
          </Stack>
        </Button>
      </Stack>
      <Stack direction='row' spacing={1}>
        <Tooltip title='Columns'>
          <ColumnsPanelTrigger render={<ToolbarButton />}>
            <ViewColumnIcon fontSize='small' color='brandBlack' />
          </ColumnsPanelTrigger>
        </Tooltip>
        <Tooltip title='Filters'>
          <FilterPanelTrigger
            render={(props, state) => (
              <ToolbarButton {...props}>
                <Badge badgeContent={state.filterCount} variant='dot'>
                  <FilterListIcon fontSize='small' color='brandBlack' />
                </Badge>
              </ToolbarButton>
            )}
          />
        </Tooltip>
      </Stack>
    </Toolbar>
  );
}

export default ProjectAuthorizersGridToolbar;
